'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const GlobalStyles = require('./GlobalStyles.js');
const themeDef = require('./themeDef.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Theme = function Theme(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      customStyles = _ref.customStyles;
  var defaultTheme = themeDef.defaultTheme;
  var mergedTheme = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultTheme), theme);
  }, [defaultTheme, theme]);
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: mergedTheme
  }, /*#__PURE__*/React__default.createElement(GlobalStyles, {
    customStyles: customStyles
  }), children);
};

module.exports = Theme;
